function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { getUiOptions } from "../utils/";

const SchemaFieldset = (_ref) => {
  let fieldset = _ref.fieldset,
      props = _objectWithoutPropertiesLoose(_ref, ["fieldset"]);

  const id = props.id,
        uiSchema = props.uiSchema,
        registry = props.registry,
        onPropertyChange = props.onPropertyChange,
        onChange = props.onChange;
  const SchemaField = registry.fields.SchemaField; // name, selected

  const name = fieldset.name,
        selected = fieldset.selected; // part of navigation?

  const uiOptions = getUiOptions(uiSchema);

  if (uiOptions.nav && !selected) {
    return null;
  } // schema, uiSchema, formData


  const fieldId = fieldset && fieldset.id;
  const fieldSchema = fieldset && fieldset.schema;
  const fieldUiSchema = fieldset && fieldset.uiSchema;
  const fieldUiOptions = fieldset && fieldset.uiOptions;
  const fieldFormData = fieldset && fieldset.formData;
  /*
  */

  if (fieldSchema) {
    return React.createElement(SchemaField, _extends({}, props, {
      name: name,
      id: fieldId,
      idPrefix: id,
      schema: fieldSchema,
      uiSchema: fieldUiSchema,
      formData: fieldFormData,
      isArrayItem: false,
      onChange: onPropertyChange(name)
    }));
  }

  if (fieldUiSchema && fieldUiOptions.fieldset) {
    return React.createElement(SchemaField, _extends({}, props, {
      name: name,
      id: fieldId,
      idPrefix: id,
      uiSchema: fieldUiSchema,
      isArrayItem: false,
      onChange: onChange
    }));
  }

  return null;
};

export default SchemaFieldset;